import React from 'react';
import { Helmet } from 'react-helmet';
import bannerBg from '../assets/img/page-banner.jpg';
import FaqAccordion from '../components/FaqAccordion';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';

function Faq() {
    return (
        <>
            <Helmet>
                <title>Întrebări Frecvente - Work Express | Construcții București</title>
                <meta name="description" content="Răspunsuri la cele mai frecvente întrebări despre serviciile de construcții și renovări Work Express din București." />
                <meta name="keywords" content="intrebari frecvente constructii, FAQ work express, informatii servicii constructii bucuresti" />
                <link rel="canonical" href="https://workexpress.ro/intrebari-frecvente" />
            </Helmet>
            <Header1 />
            <PageBanner bannerBg={bannerBg} heading="Întrebări Frecvente" currentPage="Întrebări Frecvente" />
            <section className="faq-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 wow fadeInUp">
                            <div className="faq-content">
                                <FaqAccordion
                                    question="Ce servicii oferă Work Express?"
                                    answer="Work Express oferă o gamă completă de servicii de construcții și renovări: izolații și hidroizolații, instalații electrice, vopsitorie și tapet, gleturi și finisaje, gips-carton, tencuieli și șape, montaj pardoseli, instalare AC, HVAC și IBIX. Fiecare serviciu este realizat de muncitori calificați cu experiență vastă în domeniu."
                                />
                                <FaqAccordion
                                    question="În cât timp puteți finaliza un proiect?"
                                    answer="Durata depinde de complexitatea și amploarea proiectului. După evaluarea gratuită la fața locului, vă oferim un plan detaliat cu termene clare. Ne mândrim cu servicii rapide și calitative, respectând întotdeauna termenele stabilite. Pentru proiecte urgente, putem adapta echipa pentru finalizare accelerată."
                                />
                                <FaqAccordion
                                    question="Cum pot solicita o ofertă de preț?"
                                    answer="Puteți solicita o ofertă gratuită prin telefon la 0724.273.258, prin email la office@reparatiiasfalt.ro sau folosind formularul de contact de pe site. Oferim consultanță gratuită și evaluare la fața locului pentru a vă prezenta o ofertă detaliată și transparentă."
                                />
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInUp">
                            <div className="faq-content">
                                <FaqAccordion
                                    question="Oferiți garanție pentru lucrările executate?"
                                    answer="Da, oferim garanție pentru toate lucrările executate. Perioada de garanție variază în funcție de tipul serviciului și materialele utilizate. Folosim doar materiale de calitate superioară și lucrăm conform standardelor ISO, asigurând durabilitate și satisfacție pe termen lung."
                                />
                                <FaqAccordion
                                    question="Lucrați și în weekend sau program prelungit?"
                                    answer="Da, înțelegem că mulți clienți au nevoie de flexibilitate în program. Oferim servicii și în weekend sau în afara programului normal de lucru (Luni-Vineri 08:00-18:00), la cerere. Contactați-ne pentru a discuta opțiunile de programare care se potrivesc nevoilor dumneavoastră."
                                />
                                <FaqAccordion
                                    question="Care este zona de acoperire pentru serviciile dumneavoastră?"
                                    answer="Work Express operează în București și în împrejurimi, inclusiv în Ilfov. Sediul nostru este situat în Strada Bujorilor 4, Măgurele. Pentru proiecte în alte zone, vă rugăm să ne contactați pentru a discuta posibilitățile de colaborare."
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default Faq;
